/******************************************************************************
 * This file was generated by ZenStack CLI.
 ******************************************************************************/

/* eslint-disable */
// @ts-nocheck

import { z } from 'zod';
import { ListingStatus } from '.zenstack/models';
import { ListingStatusSchema } from '../enums/ListingStatus.schema';
import { ListingDetailsSchema } from './ListingDetails.schema';
const baseSchema = z.object({
    createdAt: z.coerce.date().default(() => new Date()),
    createdById: z.string().optional(),
    updatedAt: z.coerce.date(),
    updatedById: z.string().nullish(),
    deletedAt: z.coerce.date().nullish(),
    deletedById: z.string().nullish(),
    id: z.string(),
    slug: z.string().min(1, { message: "Slugs must be between 1 and 100 characters." }).max(100, { message: "Slugs must be between 1 and 100 characters." }).regex(new RegExp("^[A-Za-z0-9-]+$"), { message: "Slugs must contain only letters, numbers, and hyphens" }).nullish(),
    status: ListingStatusSchema,
    title: z.string().trim().min(5, { message: "Listing title must be between 5 and 100 characters" }).max(100, { message: "Listing title must be between 5 and 100 characters" }),
    description: z.any(),
    details: z.lazy(() => ListingDetailsSchema),
}
).strict();
const baseSchemaWithoutDefaults = z.object({
    createdAt: z.coerce.date(),
    createdById: z.string().optional(),
    updatedAt: z.coerce.date(),
    updatedById: z.string().nullish(),
    deletedAt: z.coerce.date().nullish(),
    deletedById: z.string().nullish(),
    id: z.string(),
    slug: z.string().min(1, { message: "Slugs must be between 1 and 100 characters." }).max(100, { message: "Slugs must be between 1 and 100 characters." }).regex(new RegExp("^[A-Za-z0-9-]+$"), { message: "Slugs must contain only letters, numbers, and hyphens" }).nullish(),
    status: ListingStatusSchema,
    title: z.string().trim().min(5, { message: "Listing title must be between 5 and 100 characters" }).max(100, { message: "Listing title must be between 5 and 100 characters" }),
    description: z.any(),
    details: z.lazy(() => ListingDetailsSchema),
}
).strict();
const relationSchema = z.object({
    business: z.record(z.string(), z.unknown()),
    files: z.array(z.unknown()).optional(),
    forLease: z.record(z.string(), z.unknown()).optional(),
    atAuction: z.record(z.string(), z.unknown()).optional(),
    savedListings: z.array(z.unknown()).optional(),
    featuredListings: z.array(z.unknown()).optional(),
    comments: z.array(z.unknown()).optional(),
}
);
const fkSchema = z.object({
    businessId: z.string(),
}
);

/**
 * `Listing` schema excluding foreign keys and relations.
 */
export const ListingScalarSchema = baseSchema;


/**
 * `Listing` schema including all fields (scalar, foreign key, and relations) and validations.
 */
export const ListingSchema = ListingScalarSchema.merge(fkSchema).merge(relationSchema.partial());


/**
 * Schema used for validating Prisma create input. For internal use only.
 * @private
 */
export const ListingPrismaCreateSchema = baseSchemaWithoutDefaults.partial().passthrough();


/**
 * Schema used for validating Prisma update input. For internal use only.
 * @private
 */
export const ListingPrismaUpdateSchema = z.object({
    createdAt: z.coerce.date(),
    createdById: z.string().optional(),
    updatedAt: z.coerce.date(),
    updatedById: z.string().nullish(),
    deletedAt: z.coerce.date().nullish(),
    deletedById: z.string().nullish(),
    id: z.string(),
    slug: z.string().min(1, { message: "Slugs must be between 1 and 100 characters." }).max(100, { message: "Slugs must be between 1 and 100 characters." }).regex(new RegExp("^[A-Za-z0-9-]+$"), { message: "Slugs must contain only letters, numbers, and hyphens" }).nullish(),
    status: ListingStatusSchema,
    title: z.string().trim().min(5, { message: "Listing title must be between 5 and 100 characters" }).max(100, { message: "Listing title must be between 5 and 100 characters" }),
    description: z.any(),
    details: z.lazy(() => ListingDetailsSchema)
}).partial().passthrough();


/**
 * `Listing` schema for create operations excluding foreign keys and relations.
 */
export const ListingCreateScalarSchema = baseSchemaWithoutDefaults.partial({
    createdAt: true, createdById: true, updatedAt: true, updatedById: true, id: true, status: true
});


/**
 * `Listing` schema for create operations including scalar fields, foreign key fields, and validations.
 */
export const ListingCreateSchema = ListingCreateScalarSchema.merge(fkSchema);


/**
 * `Listing` schema for update operations excluding foreign keys and relations.
 */
export const ListingUpdateScalarSchema = baseSchemaWithoutDefaults.partial();


/**
 * `Listing` schema for update operations including scalar fields, foreign key fields, and validations.
 */
export const ListingUpdateSchema = ListingUpdateScalarSchema.merge(fkSchema.partial());

